export enum DebinStatus {
  CREADO = 0,
  ENVIADO = 1,
  ACREDITADO = 2,
  VENCIDO = 3,
  RECHAZADO = 4,
}

export enum DebinResult {
  INICIAL = 1,
  ERROR = 2,
  COMPLETED = 3,
}

export interface IDebin {
  id: string;
  debinStatus: DebinStatus;
  expiredDate: string;
  result: DebinResult;
}
